import { format } from 'date-fns';
import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  ImageField,
  BooleanField,
  NumberField,
  FunctionField,
  useTranslate,
} from 'react-admin';
import { FilterOrder } from './listPage/FilterOrder';

export default function ResourceList(props: any) {
  const t = useTranslate();
  return (
    <List
      hasCreate={false}
      hasEdit={true}
      hasShow={false}
      {...props}
      aside={<FilterOrder />}
    >
      <Datagrid rowClick='edit'>
        <NumberField source='id' />
        <TextField source='user.name' />
        <TextField source='shippingAddress' />
        <TextField source='billingAddress' />
        <TextField source='total' />
        <TextField source='productsTotalPrice' />
        <TextField source='discount' />
        <TextField source='membershipDiscount' />
        <TextField source='shippingPrice' />
        <TextField source='tax' />
        <TextField source='appliedCoupon' />
        <TextField source='paymentStatus' />
        <TextField source='shipmentStatus' />
        <TextField source='paymentMethod' />
        <TextField source='paymentReference' />
        <TextField source='shipmentRefernce' />
        <FunctionField
          sortable
          sortBy='createdAt'
          label={t('creationTime')}
          render={(record: any) =>
            format(new Date(record.createdAt), 'yyyy-MM-dd hh:mm')
          }
        />
      </Datagrid>
    </List>
  );
}
